import styled from 'styled-components';

import { sectionWrapperStyle } from 'modules/fleet/section/style';

import JobReviewSection from './component';

export default styled(JobReviewSection)`
  ${sectionWrapperStyle}

  .section__content {
    display: flex;
    overflow: hidden;
  }

  .section__loading  {
    width: 100%;
  }

  .error-container {
    width: 100%;
    .error {
      width: 100%;
    }
  }
`;
